import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import ApiService from "../../../Services/user/service";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";

const Fund = () => {
  const navigate = useNavigate();
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;
  const currency = localStorage.getItem("currentCurrency") ?? "1"; // 1 is INR, 0 is USD

  const [balanceData, setBalanceData] = useState([]);
  const [userdetails, setUserdetails] = useState([]);

  useEffect(() => {
    fetchuserdetails();
    if (currency === "1") {
      getBalanceStatementInr();
    } else {
      getBalanceStatementUsd();
    }
  }, [currency]);

  const fetchuserdetails = async () => {
    try {
      const res = await ApiService.getUserDetail(user_id);
      setUserdetails(res?.data?.data[0] || {});
    } catch (err) {
      console.log(err);
    }
  };

  const getBalanceStatementInr = async () => {
    try {
      const data = { userid: user_id, page: 1, limit: 10 };
      const res = await ApiService.balanceStatementInr(data);
      setBalanceData(res?.data?.data || []);
    } catch {
      setBalanceData([]);
    }
  };

  const getBalanceStatementUsd = async () => {
    try {
      const data = { userid: user_id, page: 1, limit: 10 };
      const res = await ApiService.balanceStatement(data);
      setBalanceData(res?.data?.data || []);
    } catch {
      setBalanceData([]);
    }
  };

  let availableBalance = 0;
  let availableMargin = 0;

  if (userdetails && Object.keys(userdetails).length > 0) {
    if (currency === "1") {
      availableBalance = userdetails.Inr_Balance || 0;
      availableMargin = (userdetails.Inr_Balance || 0) * (userdetails.limit || 1);
    } else {
      availableBalance = userdetails.Balance || 0;
      availableMargin = (userdetails.Balance || 0) * (userdetails.limit || 1);
    }
  }

  return (
    <div className="mobile-fund-container pb-5 mb-5 container-fluid bg-body text-body">
      <style>
        {`
          .mobile-fund-container {
            min-height: 100vh;
            font-family: 'Inter', sans-serif;
            padding: 20px 15px;
            margin-top: -100px;
            position: relative;
            z-index: 10;
          }
          @media (min-width: 769px) {
             .mobile-fund-container {
                 display: none;
             }
          }
          .fund-header {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 25px;
            padding-top: 20px;
            position: relative;
          }
          .fund-title {
            font-size: 1.25rem;
            font-weight: 600;
          }
          
          /* FUND SECTION STYLES */
          .fund-card {
            background: #111;
            border-radius: 20px;
            padding: 20px;
            color: white;
            margin-bottom: 15px;
            border: 1px solid #333;
          }
          .fund-row {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 15px;
          }
          .fund-row:last-child {
            margin-bottom: 0;
          }
          .fund-icon {
            background: rgba(32, 201, 151, 0.15);
            color: #20c997;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .fund-details p {
            margin: 0;
            font-size: 0.8rem;
            color: #aaa;
          }
          .fund-details h4 {
            margin: 0;
            font-size: 1.2rem;
            font-weight: bold;
            color: white;
          }
          .action-buttons {
            display: flex;
            gap: 15px;
            margin-bottom: 25px;
          }
          .btn-action {
            flex: 1;
            padding: 12px;
            border-radius: 12px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            text-decoration: none;
            border: 1px solid;
          }
          .btn-deposit {
            background: rgba(32, 201, 151, 0.1);
            color: #20c997;
            border-color: rgba(32, 201, 151, 0.3);
          }
          .btn-withdraw {
            background: rgba(255, 77, 77, 0.1);
            color: #ff4d4d;
            border-color: rgba(255, 77, 77, 0.3);
          }
          .btn-history {
            background: #1a2c26;
            color: #20c997;
            width: 100%;
            padding: 12px;
            border-radius: 12px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            border: none;
            margin-bottom: 20px;
          }
          .history-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .history-item {
            background: var(--bs-body-bg, #fff);
            border: 1px solid var(--bs-border-color, #dee2e6);
            border-radius: 12px;
            padding: 12px 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        `}
      </style>

      {/* TOP SECTION: TITLE */}
      <div className="fund-header text-body">
        <span className="fund-title">Fund</span>
      </div>

      <div className="fund-section " style={{ marginTop: "65px" , padding:"5px"  }}>
        <div className="fund-card">
          <div className="fund-row">
            <div className="fund-icon">
              <Icons.Wallet size={20} />
            </div>
            <div className="fund-details">
              <p>Available Fund</p>
              <h4>{currency === "1" ? "₹" : "$"}{availableBalance.toFixed(2)}</h4>
            </div>
          </div>
          <div className="fund-row">
            <div className="fund-icon">
              <Icons.TrendingUp size={20} />
            </div>
            <div className="fund-details">
              <p>Available Margin</p>
              <h4>{currency === "1" ? "₹" : "$"}{availableMargin.toFixed(2)}</h4>
            </div>
          </div>
        </div>

        {/* Deposit & Withdraw Buttons */}
        <div className="action-buttons">
          <Link to="/user/deposit" className="btn-action btn-deposit">
            <Icons.PlusCircle size={18} /> Deposit
          </Link>
          <Link to="/user/withdraw" className="btn-action btn-withdraw">
            <Icons.MinusCircle size={18} /> Withdraw
          </Link>
        </div>

        {/* Transaction History */}
        <Link to="/user/balance-statement" style={{ textDecoration: "none" }}>
          <div className="btn-history">
            <Icons.History size={18} /> Transaction History
          </div>
        </Link>

        {balanceData.length === 0 ? (
          <div className="text-center mt-4 mb-4">
            <div style={{
              background: '#1a2c26', color: '#20c997', width: '60px', height: '60px',
              borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px'
            }}>
              <Icons.Receipt size={24} />
            </div>
            <h6 className="fw-bold mb-1">No transactions yet</h6>
            <small className="text-muted">Your history will appear here</small>
          </div>
        ) : (
          <div className="history-list">
            {balanceData.slice(0, 5).map((row, index) => {
              const credit = row.type === "CREDIT";
              const amt = Number(row.Amount) || 0;
              return (
                <div key={index} className="history-item">
                  <div>
                    <div className="fw-semibold">{row.message}</div>
                    <div className="text-muted" style={{ fontSize: "11px" }}>{fDateTimesec(row.createdAt)}</div>
                  </div>
                  <div className="text-end">
                    <div className={`fw-bold ${credit ? "text-success" : "text-danger"}`}>
                      {credit ? "+" : "-"}{currency === "1" ? "₹" : "$"}{amt.toFixed(2)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

    </div>
  );
};

export default Fund;
